module.exports = __webpack_public_path__ + "media/images/icons/credit-c89e9c48223e78e0254644a8566c5c90.svg";